import { render, staticRenderFns } from "./DriverType.vue?vue&type=template&id=1bc4d2e0&"
import script from "./DriverType.vue?vue&type=script&lang=js&"
export * from "./DriverType.vue?vue&type=script&lang=js&"
import style0 from "./DriverType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports